// Initialize Read More functionality
import { getTranslations } from "/Assets/js/common/translations.js";

document.addEventListener("DOMContentLoaded", function () {
    const readMores = document.querySelectorAll("div.shorten");

    if (readMores.length > 0) {
        import(/* webpackChunkName: "read-more" */ "/Assets/libs/read-more/read-more.js").then(async (module) => {
            getTranslations().then(t => {
                module.default(readMores, {
                    moreText: t.JsResources.Translations.Common.ReadMore,
                    lessText: t.JsResources.Translations.Common.ReadLess
                }).init();
            });
        });
    }
});